import angular from 'angular';
import parseCategory from 'App/resources/parsers/category';

angular.module('upResources').service('ParseProductCategory', [
	function () {
		return category => parseCategory(category);
	}
]);
